<template>
  <div class="introVideosContent">
    <swiper
      ref="introVideosCustomizerSwiper"
      @transitionEnd="onTouchEnd"
      @slideChange="onSwiperSlideChange"
      class="introVideoSwiper"
      :options="swiperOption"
    >
      <swiper-slide v-for="(step, index) in steps" :key="index">
        <video :ref="'step'+ index" @ended="onVideoEnded" playsinline autoplay muted>
          <source src="" type="video/mp4" />
        </video>
      </swiper-slide>
    </swiper>

    <div class="introVideosArrows">
      <button class="button-carrousel" type="button">
        <span
          class="icon-arrow-left-indicator-open"
          slot="button-previous"
        ></span>
      </button>
      <div class="introVideosText">
        <p>{{ translations[currentStep.description] }}</p>
        <div class="swiper-pagination-ugc-introvideos" slot="pagination"></div>
      </div>
      <button class="button-carrousel"  @click="onRightClick" type="button">
        <span
          class="icon-arrow-right-indicator-open"
          slot="button-next"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

import introVideos from '@/mixins/IntroVideos';

export default {
  name: 'IntroVideos',
  mixins: [introVideos],
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    assetsPath: String,
    onNext: Function,
    onSlideChange: Function,
    steps: Array,
  },
};
</script>
